export default __webpack_public_path__ + "static/media/trashcan.93f1c574.svg";